/**
 * Who initiated the cancellation of an appointment (TM-9064, slice 5).
 *
 * Recorded explicitly on `AppointmentParticipant` (as `cancellationOrigin`)
 * because the cancellation fee turns on it: only `PATIENT` cancellations
 * are fee-eligible (and only those that fall outside the practice's grace
 * window). `PRACTICE` cancellations are audited but never charged.
 */
export var CancellationOrigin;
(function (CancellationOrigin) {
    CancellationOrigin["PATIENT"] = "PATIENT";
    CancellationOrigin["PRACTICE"] = "PRACTICE";
})(CancellationOrigin || (CancellationOrigin = {}));
//# sourceMappingURL=cancellation-origin.enum.js.map